import React, { useState } from 'react';

import { useDispatch } from 'react-redux';
import { getDocumentBlobUrl } from '@/src/utils';

const isImageOrPdf = mimeType =>
  mimeType.includes('image') || mimeType.includes('pdf');

const useDocumentThumbnail = document => {
  const { type, id, encryptThumbnailS3Id } = document;
  const dispatch = useDispatch();
  const [documentThumbnailUrl, setDocumentThumbnailUrl] = useState<string>();
  React.useEffect(() => {
    const getDocumentThumbnail = async () => {
      const url =
        isImageOrPdf(type) && encryptThumbnailS3Id
          ? await getDocumentBlobUrl(dispatch, id, true)
          : `/static/images/default_document.svg`;
      setDocumentThumbnailUrl(url);
    };
    getDocumentThumbnail();
  }, [id, type, encryptThumbnailS3Id]);

  return documentThumbnailUrl;
};

export default useDocumentThumbnail;
